import _ from 'lodash';

export const isNotEmpty = (obj: any) => {
    return !_.isEmpty(obj);
};
